import React from "react";
import { useField } from "formik";

/**
 * Native select input wrapper to support dynamic option rendering and Formik context.
 * @param {{
 * name: string,
 * label: string,
 * options: { value: string, label: string }[],
 * disabled?: boolean,
 * placeholder?: string,
 * }} props
 * @returns {React.FunctionComponent}
 */
export default function Select({
    name,
    label,
    placeholder = "Choose..",
    options,
    errorClass,
    onChange,
    ...rest
}) {
    const [field, meta] = useField({ name, label, ...rest });

    const handleChange = (e) => {
        field.onChange(e);
    
        if (onChange) {
          onChange(e);
        }
      };

    return (
        <div className="w-100">
            {label && <label htmlFor={name}>{label}</label>}
            <select
                className="form-select"
                id={name}
                name={name}
                {...field}
                {...rest}
                value={field.value || ""}
                onChange={handleChange}
            >
                <option value="" disabled hidden default>
                    {placeholder}
                </option>
                {options.map((optn) => (
                    <option
                        value={optn.value}
                        label={optn.label || optn.value}
                        key={optn.value}
                    />
                ))}
            </select>

            <div
                hidden={meta.touched && meta.error}
                className={`invalid-feedback mb-0 mt-0 w-fit ${errorClass}`}
                style={{ display: "block" }}
            >
                {meta.error}
            </div>
        </div>
    );
}
